// breakpoints in rem
export const breakpoints = {
  xxs: 20, // 320px
  xs: 30, // 480px
  sm: 48, // 768px
  ms: 62, // 992px
  md: 64, // 1024px
  lg: 80, // 1280px
  xl: 90, // 1440px
  xxl: 120, // 1920px
  xxxl: 140, // 2240px
};

export default breakpoints;
